export function toArray(input, scope = document) {
	if (typeof input === 'string') {
		const elements = Array.from(scope.querySelectorAll(input));
		return elements.length ? elements : false;
	}

	return Array.from(input);
}
